/**
 * Soft shapes and hand-drawn-feeling dividers. Everything here is decorative and hidden from
 * assistive technology.
 */

/** Organic blob used behind the portrait and in section corners. */
export function Blob({ className = '', drift = false }: { className?: string; drift?: boolean }) {
  return (
    <svg
      viewBox="0 0 200 200"
      aria-hidden="true"
      className={`${className} ${drift ? 'animate-drift-slow' : ''}`}
    >
      <path
        fill="currentColor"
        d="M48.4,-58.7C61.3,-48.3,69.3,-31.9,72.4,-14.7C75.5,2.6,73.6,20.7,64.9,34.4C56.2,48.1,40.6,57.4,24.1,63.2C7.6,69,-9.9,71.3,-26.6,66.6C-43.3,61.9,-59.2,50.2,-67.2,34.5C-75.2,18.8,-75.4,-0.9,-69.4,-17.8C-63.4,-34.7,-51.2,-48.8,-37,-58.7C-22.8,-68.6,-6.5,-74.3,8.9,-72.6C24.4,-70.9,35.5,-69.1,48.4,-58.7Z"
        transform="translate(100 100)"
      />
    </svg>
  );
}

/** A gently uneven divider — the point is that it is not a straight rule. */
export function WavyDivider({
  className = '',
  flip = false,
}: {
  className?: string;
  flip?: boolean;
}) {
  return (
    <svg
      viewBox="0 0 1440 60"
      preserveAspectRatio="none"
      aria-hidden="true"
      className={`block w-full ${flip ? 'rotate-180' : ''} ${className}`}
    >
      <path
        fill="currentColor"
        d="M0,32 C180,4 320,54 520,38 C700,24 820,-6 1010,10 C1180,24 1300,50 1440,30 L1440,60 L0,60 Z"
      />
    </svg>
  );
}

/** Short hand-drawn underline used beneath section headings. */
export function Squiggle({ className = '' }: { className?: string }) {
  return (
    <svg viewBox="0 0 120 12" aria-hidden="true" className={`h-3 w-28 ${className}`}>
      <path
        d="M2,8 C18,2 30,10 46,6 C62,2 74,10 90,6 C102,3 110,7 118,5"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
